import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, ControlLabel, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { WithAuth } from '../Authorization/WithAuth';
import { UserTransferList } from './UserTransferList';

/**
 * Formulario reutilizable para crear y editar un MedicalCenter.
 * Usa estado local (no Formik) porque el form es simple y el select de usuarios requiere
 * objetos completos para react-select (no solo IDs).
 */
export const MedicalCenterForm = ({ initialValues, onSubmit, onCancel, tenantId = null, isSuperAdmin = false }) => {
    const { t } = useTranslation();
    const [name, setName] = React.useState(initialValues.name ?? '');
    const [selectedUserIds, setSelectedUserIds] = React.useState(initialValues.userIds ?? []);
    const [submitting, setSubmitting] = React.useState(false);

    const initialSelectedUsers = initialValues.users ?? [];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) return;
        setSubmitting(true);
        await onSubmit({ name, userIds: selectedUserIds });
        setSubmitting(false);
    };

    return (
        <Grid fluid>
            <Row>
                <Col md={12}>
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">{t('medicalCenter.formTitle', 'Datos del Centro')}</h4>
                            </div>
                            <div className="content">
                                <fieldset>
                                    <FormGroup>
                                        <Grid fluid>
                                            <Row>
                                                <Col sm={4}>
                                                    <ControlLabel>{t('medicalCenter.name', 'Nombre')}</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        name="name"
                                                        value={name}
                                                        onChange={e => setName(e.target.value)}
                                                        autoComplete="off"
                                                        required
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={12}>
                                                    <UserTransferList
                                                        initialSelectedUsers={initialSelectedUsers}
                                                        onSelectionChange={setSelectedUserIds}
                                                        tenantId={tenantId}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </FormGroup>
                                </fieldset>
                                <fieldset>
                                    <Grid fluid>
                                        <Row>
                                            <Col sm={1} smOffset={10}>
                                                <button type="button" className="btn btn-info" onClick={onCancel}>
                                                    {t('buttons.cancel', 'Cancelar')}
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                {(isSuperAdmin
                                                    ? <button className="btn btn-success" type="submit" disabled={submitting}>
                                                        {t('buttons.save', 'Guardar')}
                                                    </button>
                                                    : <WithAuth requiredPermission={["MedicalCenter.Create", "MedicalCenter.Edit"]}>
                                                        <button className="btn btn-success" type="submit" disabled={submitting}>
                                                            {t('buttons.save', 'Guardar')}
                                                        </button>
                                                    </WithAuth>
                                                )}
                                            </Col>
                                        </Row>
                                    </Grid>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </Col>
            </Row>
        </Grid>
    );
};
